import styled from 'styled-components'
import { themeObject, textModels } from 'Pages/landings/newLandings/common/style'

export const Wrapper = styled.div`
	display: flex;
	&:not(:last-child) {
		margin-bottom: 16px;
	}
`

export const TextWrapper = styled.div`
	display: flex;
	flex-direction: column;
`

export const Title = styled.p`
	${textModels('notAdaptive', 'xl', '400')}
	color: ${themeObject.colors.grey[800]};
	margin-bottom: 8px;
`
export const Subtitle = styled.p`
	${textModels('notAdaptive', 'm', '400')}
	color: ${themeObject.colors.grey[600]};
`
